angular.module('cian.serp.item')
.controller('PremiumStoreCtrl', ["$scope", "$timeout", '$log', "close", "OfferService", "UserService", function ($scope, $timeout, $log, close, OfferService, UserService) {
  $scope.premiumIsLoading = true;

  OfferService
    .getPremiumPrice($scope.offer)
    .then(function(data) {
      var premiumInfos = data.premiumInfos;
      var sortedPremium = premiumInfos.sort(function(a, b) {
        return a.publishPeriodInDays - b.publishPeriodInDays
      });
      $scope.premiumPriceForDay = sortedPremium[0].price;
      $scope.premiumDays = sortedPremium[0].publishPeriodInDays;
    })
    .finally(function() {
      $scope.premiumIsLoading = false;
    });

  $scope.periods = OfferService.getPremiumPeriods();
  $scope.selectedPeriod = $scope.periods[0];

  if ($scope.offer.premium.isCodeProtected) {
    UserService
      .sendSecret()
      .then(function(data) {
        $log.debug(data);
      });
  }

  $scope.setPremium = function() {
    OfferService
      .setPremium($scope.offer, {
        period: $scope.selectedPeriod.value,
        secretCode: $scope.secretCode,
        isCodeRequired: $scope.offer.premium.isCodeProtected
      })
      .then(function(msg) {
        Notifications.add({
            type: 'success',
            content: msg,
            timeout: 10000
        });
      }, function(msg) {
        Notifications.add({
            type: 'error',
            content: msg,
            timeout: 10000
        });
      });
      close();
  };
}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.premium_store.js
// module id = 494
// module chunks = 0